import * as React from "react";
import { useState, useEffect, useCallback } from "react";
import SideNavigation from "./components/SideNavigation/SideNavigation";
import { Edit } from "@mui/icons-material";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  MenuItem,
  Menu,
  Snackbar,
  Alert,
  Box,
  ToggleButton,
  ToggleButtonGroup,
} from "@mui/material";
import ChatFlow from "./components/ChatFlow/ChatFlow";
import MyPerformance from "./components/MyPerformance/MyPerformance";
import { getUserSessions } from "./redux/slice/get-user-sessions";
import { useDispatch, useSelector } from "react-redux";
import {
  newChatSession,
  newchatfetchStreamData,
} from "./redux/slice/new-stream-thunk";
import {
  newChatSessionId,
  checkUserSessionId,
} from "./redux/slice/new-chat-session";
import Rename from "./assets/images/Rename.svg";
import Delete from "./assets/images/Delete.svg";
import ErrorSnack from "./assets/images/ErrorSnack.svg";
import RenameDialog from "./components/RenameDialog/RenameDialog";
import DeleteDialog from "./components/DeleteDialog/DeleteDialog";
import { deleteUserSession } from "./redux/slice/delete-user-session";
import moment from "moment";
import NetworkStatus from "./components/NetworkStatus";
import "./App.scss";
import {
  useLocation,
  useNavigate,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import SnackbarComponent from "./components/Snackbar/Snackbar";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import MobileHeaderComponent from "./mobilecomponents/MobileHeaderComponent/MobileHeaderComponent";
import { getUserChats } from "./redux/slice/get-user-chats";
import { fetchStreamData } from "./redux/slice/stream-thunk";
import { postUserChat } from "./redux/slice/post-user-chat";
import {
  convertToMessageFormat,
  getCurrentDateTime,
} from "./components/MessageConversionFormat";
import Header from "./components/Header/Header";
import {
  inputUpdate,
  messageUpdate,
  resetMessages,
  disableFormContol,
  productsUpdate,
  keyMessageUpdate,
  newChatStateUpdate,
} from "./redux/slice/snackbar";
import { getUserName } from "./redux/slice/get-user-name";
import * as microsoftTeams from "@microsoft/teams-js";
import secureLocalStorage from "react-secure-storage";
import { generateToken } from "./redux/slice/generate-token";
import SelectRepDialog from "./components/SelectRepDialog/SelectRepDialog";
import { getRepEmails, setSelectedEmail } from "./redux/slice/get-rep-emails";
import { getSpeechConfig } from "./redux/slice/azure-speech-config";
import { getOktaLoginUrl } from "./redux/config";
import Training from "./components/TrainingPage/Training";
import HomePage from "./pages/HomePage";
import {
  getQueryParam,
  bootstrapAuthFromUrl,
  startSessionRefresh,
  stopSessionRefresh,
  isDelegatedSession,
  getIncomingDisplayName,
} from "./utils/common";
import { fetchAndPersistIncomingDisplayName } from "./utils/displayIdentity";
import { loadCurrentUser } from "./redux/slice/auth-slice";
import { sendSessionEnd } from "./utils/sessionActivity";
import NoAccessPage from "./pages/NoAccessPage";
import ErrorPage from "./pages/ErrorPage";
import SessionExpiredPage from "./pages/SessionExpiredPage";
import AuthenticatedRoute from "./components/AuthenticatedRoute";
import { hasFirstLayerApiFailure } from "./utils/firstLayerApiError";
// import { hideSnackbar } from "./redux/slice/snackbar";

const theme = createTheme({
  typography: {
    fontFamily: "Mulish, sans-serif",
  },
  components: {
    MuiTypography: {
      styleOverrides: {
        root: {
          fontFamily: "Mulish, sans-serif",
        },
      },
    },
  },
});

function App() {
  const dispatch = useDispatch();
  const location = useLocation();
  console.log("environment", process.env);

  const navigate = useNavigate();
  const source = getQueryParam(location.search, "source");
  const client = "UT";

  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [sessionId, setSessionId] = useState("");
  const userChats = useSelector((state) => state.userChats.userChats);
  const userChat = useSelector((state) => state.userChat.userChat);
  const checkone = useSelector((state) => state?.userSessions?.userSessions);
  const chatUpdate = useSelector((state) => state.newChat.data);
  const messages = useSelector((state) => state.snackbar.messages);
  const input = useSelector((state) => state.snackbar.input);
  const [userName, setUserName] = useState("New Session");
  const [selectedItem, setSelectedItem] = useState(null);
  const [chatscroll, setChatScroll] = useState("down");
  const deleteUserError = useSelector((state) => state.deleteUser.error);
  const newChatError = useSelector((state) => state.newChat.error);
  const newChatStreamError = useSelector((state) => state.newChatStream.error);
  const renameUserError = useSelector((state) => state.renameUser.error);
  const userChatError = useSelector((state) => state.userChat.error);
  const userChatsError = useSelector((state) => state.userChats.error);
  const userFeedbackError = useSelector((state) => state.userFeedback.error);
  const userSessionsError = useSelector((state) => state.userSessions.error);
  const [authorized, setAuthorized] = useState(true);
  const [repDialogOpen, setRepDialogOpen] = useState(false);
  const [view, setView] = useState("performance");
  const viewParam = getQueryParam(location.search, "tab");

  const authState = useSelector((state) => state.auth);
  const authUser = authState.user;
  const authReady = !authState.loading;
  const userEmail = authUser?.email || "";
  const businessFunction = authUser?.business_function || "";
  const hasAccess = authUser?.has_access === true;
  const token = "__cookie__";

  useEffect(() => {
    bootstrapAuthFromUrl();
    dispatch(loadCurrentUser());
    startSessionRefresh();
    return () => stopSessionRefresh();
  }, [dispatch]);

  // Resolve the "tab" label we log for last_tab.
  // On the homepage, prefer the toggle view (performance | repassist | qbr).
  // On non-homepage routes (/training, /no-access, /error), fall back to the
  // pathname so last_tab doesn't inherit a stale homepage value when the
  // user closes the tab or logs out from those pages.
  const resolvedTab = React.useMemo(() => {
    if (location.pathname === "/") return view;
    const label = location.pathname.replace(/^\/+/, "").replace(/\/+$/, "");
    return label || "unknown";
  }, [location.pathname, view]);

  // Keep a ref to the current tab so the pagehide listener (mounted once)
  // always reads the latest value without needing to re-attach on tab change.
  const viewRef = React.useRef(resolvedTab);
  useEffect(() => {
    viewRef.current = resolvedTab;
  }, [resolvedTab]);

  // UI session tracking: fire ui_session_end via sendBeacon on browser
  // close / tab hide so we can identify users who landed on the performance
  // tab and left without asking a question. Explicit logout is handled
  // separately in Header.handleLogout.
  useEffect(() => {
    const onPageHide = () => {
      sendSessionEnd("close", viewRef.current);
    };
    // pagehide is fired on both real unloads and BFCache transitions and is
    // the most reliable place to send beacons across browsers.
    window.addEventListener("pagehide", onPageHide);
    return () => {
      window.removeEventListener("pagehide", onPageHide);
    };
  }, []);

  useEffect(() => {
    if (
      authReady &&
      authUser &&
      isDelegatedSession() &&
      !getIncomingDisplayName()
    ) {
      fetchAndPersistIncomingDisplayName().catch(() => {});
    }
  }, [authReady, authUser]);

  useEffect(() => {
    if (
      viewParam === "repassist" ||
      viewParam === "performance" ||
      viewParam === "qbr"
    ) {
      setView(viewParam);
    } else {
      setView("performance");
    }
  }, [viewParam]);

  const handleViewChange = (_, next) => {
    if (next !== null) {
      setView(next);
      setOpen(false);

      const params = new URLSearchParams();
      params.set("tab", next);

      if (source) {
        params.set("source", source);
      }

      navigate(
        {
          pathname: "/",
          search: `?${params.toString()}`,
        },
        { replace: true },
      );
    }
  };
  // useEffect(async() => {
  //   // Initialize the Microsoft Teams SDK
  //   if(source === 'teams'){

  //     // microsoftTeams.initialize();

  //     // Get the user's context
  //     // microsoftTeams?.getContext((context) => {
  //     //   if (context?.userPrincipalName) {
  //         // setEmail(context.userPrincipalName);  // This property contains the user's email
  //         secureLocalStorage.setItem("userEmail", 'Supriyo@m1tb.onmicrosoft.com');
  //         const data = await dispatch(generateToken('Supriyo@m1tb.onmicrosoft.com')).unwrap();
  //         secureLocalStorage.setItem("token", data);
  //         // console.log('secular',data)
  //     //   }
  //     // }
  //   // );
  //   }else{
  //     secureLocalStorage.setItem("userEmail", getQueryParam(location.search, "user_email"));
  //     secureLocalStorage.setItem("token", getQueryParam(location.search, "token"));
  //   }
  // }, []);
  useEffect(() => {
    if (!authReady || !userEmail) return;

    if (source === "teams") {
      microsoftTeams.initialize();
      microsoftTeams?.getContext(async (context) => {
        secureLocalStorage.setItem("userEmail", context.userPrincipalName);
      });
    } else {
      secureLocalStorage.setItem("userEmail", userEmail);
      secureLocalStorage.setItem("businessFunction", businessFunction);
    }
  }, [authReady, source, userEmail, businessFunction, dispatch]);

  useEffect(() => {
    if (!authReady || !userEmail || !hasAccess) return;
    dispatch(getSpeechConfig());
  }, [authReady, userEmail, hasAccess, dispatch]);

  useEffect(() => {
    if (!authReady || !userEmail) return;

    dispatch(setSelectedEmail(userEmail));
  }, [authReady, userEmail, dispatch]);

  const errorCheck =
    deleteUserError === "Unauthorized" ||
    newChatError === "Unauthorized" ||
    newChatStreamError === "Unauthorized" ||
    renameUserError === "Unauthorized" ||
    userChatError === "Unauthorized" ||
    userChatsError === "Unauthorized" ||
    userFeedbackError === "Unauthorized" ||
    userSessionsError === "Unauthorized";

  useEffect(() => {
    if (!authReady) return;

    if (!userEmail) {
      redirectToLogin();
      return;
    }

    if (!hasAccess) return;

    dispatch(setSelectedEmail(userEmail));
    dispatch(getRepEmails());
  }, [authReady, userEmail, hasAccess, dispatch]);

  const firstLayerFailed = useSelector(hasFirstLayerApiFailure);

  useEffect(() => {
    if (!authReady || !userEmail) return;

    const statusPath = location.pathname;
    if (statusPath === "/error" || statusPath === "/no-access") return;

    if (!hasAccess) {
      navigate("/no-access", { replace: true });
      return;
    }

    if (firstLayerFailed) {
      navigate("/error", { replace: true });
    }
  }, [
    authReady,
    userEmail,
    hasAccess,
    firstLayerFailed,
    location.pathname,
    navigate,
  ]);

  const redirectToLogin = () => {
    const loginUrl = getOktaLoginUrl();
    window.location.replace(loginUrl);
  };

  const handleSelectRepClose = () => setRepDialogOpen(false);
  const openSelectRepDialog = React.useCallback(() => {
    setRepDialogOpen(true);
  }, []);

  useEffect(() => {
    if (errorCheck) {
      return setAuthorized(false);
    } else {
      return setAuthorized(true);
    }
  }, [errorCheck]);

  const handleChats = (sessionId) => {
    const payload = {
      sessionId: sessionId,
      userEmail,
      token,
      client,
    };
    dispatch(getUserChats(payload));
  };
  // useEffect(() => {
  //   const userSessionPayload = {
  //     userEmail: userEmail,
  //     token: token,
  //     client,
  //   };
  //   let getData = setTimeout(() => {
  //     if (source !== "teams" && client !== "UT") {
  //       dispatch(getUserName(userSessionPayload));
  //     }
  //     // dispatch(getUserSessions(userSessionPayload));
  //   }, 0);
  //   return () => clearTimeout(getData);
  // }, [secureLocalStorage.getItem("token")]);

  const handlemessageUpdate = (chats) => {
    dispatch(messageUpdate(convertToMessageFormat(chats)));
  };

  useEffect(() => {
    dispatch(resetMessages());
    dispatch(newChatStateUpdate(false));
    if (userChats.length > 0) {
      setUserName(userChats[0].ai_metadata?.user_session_name);
      handlemessageUpdate(userChats);
      dispatch(disableFormContol(false));
      dispatch(productsUpdate(""));
      dispatch(keyMessageUpdate(""));
    } else {
      dispatch(resetMessages());
      dispatch(newChatStateUpdate(false));
    }
    setSessionId(userChats[0]?.user_session_id);
  }, [userChats]);

  console.log("userChats[0]?", userChats[0]);

  useEffect(() => {
    const formattedMessages = convertToMessageFormat([userChat]);
    if (formattedMessages[0].text !== "") {
      dispatch(messageUpdate([...messages, formattedMessages[1]]));
    }
    console.log("userChat called", userChat);
  }, [userChat]);

  useEffect(() => {
    if (chatUpdate?.chat_id) {
      setUserName(chatUpdate.user_session_name);
      handlemessageUpdate([chatUpdate]);
    }
    setSessionId(chatUpdate?.user_session_id);
  }, [chatUpdate]);

  // const handleSend = async (fInput) => {
  //   let inputValue = input;
  //   console.log('input', messages)
  //   if (inputValue.trim().length === 0) {
  //     if (fInput.trim().length === 0) {
  //       return;
  //     } else {
  //       inputValue = fInput;
  //       dispatch(inputUpdate(fInput))
  //     }
  //   }
  //   dispatch(messageUpdate([{
  //     text: inputValue,
  //     sender: "user",
  //     chatId: "",
  //     userSessionId: sessionId || "",
  //     feedback: "",
  //     time: getCurrentDateTime(),
  //     options: [],
  //     email: "",
  //     withoutMarkDown: "",
  //   },]
  //   ))
  //   if ((messages.length > 1 && input === 'I have just finished my call with dr. Payne - can you log my notes') || input === 'I have just finished my call with dr. Payne - can you log my notes') {
  //     setTimeout(() => {
  //       dispatch(messageUpdate([{
  //         text: 'bottext',
  //         sender: "bot",
  //         chatId: "",
  //         userSessionId: "",
  //         feedback: "",
  //         time: getCurrentDateTime(),
  //         options: [],
  //         email: "",
  //         withoutMarkDown: "",
  //       },]
  //       ))
  //     }, 1000);

  //   }
  //   if ((messages.length === 0 && input !== 'I have just finished my call with dr. Payne - can you log my notes'||messages[0]?.text === 'I have just finished my call with dr. Payne - can you log my notes')) {
  //     setUserName("New chat");

  //     try {
  //       const newChatSessionPayload = {
  //         userEmail: userEmail,
  //         token: token,
  //         client
  //       };
  //       const payload = {
  //         human: inputValue,
  //         human_metadata: {},
  //         streaming: "true",
  //         streaming_source: "react"
  //       };
  //       const api1Data = await dispatch(
  //         newChatSession(newChatSessionPayload)
  //       ).unwrap();
  //       const passParam = {
  //         sessionId: api1Data.user_session_id,
  //         payload: payload,
  //         userEmail: userEmail,
  //         token: token,
  //         client
  //       };

  //       await dispatch(newchatfetchStreamData(passParam)).unwrap();
  //       await dispatch(getUserSessions(newChatSessionPayload)).unwrap();
  //     } catch (err) {
  //       console.error("Error:", err);
  //     }
  //   }
  //   if (messages.length > 1 && input !== 'I have just finished my call with dr. Payne - can you log my notes' && messages[0]?.text !== 'I have just finished my call with dr. Payne - can you log my notes') {
  //     let payload = {
  //       human: inputValue,
  //       human_metadata: {},
  //       streaming: "true",
  //       streaming_source: "react"
  //     };
  //     const data = {
  //       sessionId: sessionId,
  //       data: payload,
  //       userEmail,
  //       token,
  //       client
  //     };
  //     try {
  //       await dispatch(fetchStreamData(data));
  //     } catch (err) {
  //       console.error("Error:", err);
  //     }
  //     setChatScroll("down");
  //   }

  //   dispatch(inputUpdate(''))
  // };
  const handleInputValue = useCallback((data) => {
    dispatch(inputUpdate(data));
  }, []);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  if (!authorized && !userEmail) {
    return (
      <Snackbar
        open={errorCheck}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        className="snackbar-for-toast-alert"
      >
        <Alert
          className="snackbar-alert"
          sx={{ width: "100%", display: "flex", alignItems: "center" }}
        >
          <img
            src={ErrorSnack}
            alt="success-snack"
            style={{ width: "24px", height: "24px", marginRight: "8px" }}
          />
          <span>Unauthorized!</span>
        </Alert>
      </Snackbar>
    );
  }

  return (
    <ThemeProvider theme={theme}>
      <Routes>
        <Route
          path="/no-access"
          element={
            <AuthenticatedRoute>
              <NoAccessPage />
            </AuthenticatedRoute>
          }
        />
        <Route
          path="/error"
          element={
            <AuthenticatedRoute>
              <ErrorPage />
            </AuthenticatedRoute>
          }
        />
        <Route
          path="*"
          element={
            <>
              <Header onLogoutOpenRep={openSelectRepDialog} />
              {authorized ? (
                <>
                  <MobileHeaderComponent />
                  <SnackbarComponent />
                  <NetworkStatus />

                  <Routes>
                    <Route
                      path="/"
                      element={
                        <HomePage
                          view={view}
                          handleViewChange={handleViewChange}
                          open={open}
                          handleInputValue={handleInputValue}
                          chatscroll={chatscroll}
                          setChatScroll={setChatScroll}
                          sessionId={sessionId}
                          handleChats={handleChats}
                          handleDrawerOpen={handleDrawerOpen}
                          handleDrawerClose={handleDrawerClose}
                        />
                      }
                    />
                    <Route path="/training" element={<Training />} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                  </Routes>

                  <SelectRepDialog
                    open={repDialogOpen}
                    handleClose={handleSelectRepClose}
                  />
                </>
              ) : (
                <SessionExpiredPage />
              )}
            </>
          }
        />
      </Routes>
    </ThemeProvider>
  );
}

export default App;
